import AxiosInstance from 'src/shared/services/axios/interceptor';
import { InvoiceAddressResponse } from 'src/modules/member/invoicerecipient/models/invoiceAddressResponse';
import { InvoiceAddressSearchFilter } from 'src/modules/member/invoicerecipient/models/invoiceAddressSearchFilter';
import { InvoiceAddressRequest } from 'src/modules/member/invoicerecipient/models/invoiceAddressRequest';
import { InvoiceAddressPut } from 'src/modules/member/invoicerecipient/models/invoiceAddressPut';
import { PagedResult } from '../models/pagedResult';

const controller = 'InvoiceAddress';

export const getInvoiceAddressById = (id: number) => {
  return AxiosInstance.get<InvoiceAddressResponse>(`${controller}/${id}`);
};

export const getAllInvoiceAddress = (searchFilter: InvoiceAddressSearchFilter) => {
  return AxiosInstance.get<PagedResult<InvoiceAddressResponse>>(controller, { params: searchFilter });
};

export const createInvoiceAddress = (data: InvoiceAddressRequest) => {
  return AxiosInstance.post(controller, data);
};

export const updateInvoiceAddress = (data: InvoiceAddressPut) => {
  return AxiosInstance.put(controller, data);
};

export const deleteInvoiceAddressById = (id: number) => {
  return AxiosInstance.delete(`${controller}/${id}`);
};
